import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllCarPositionsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type AllCarPositionsQuery = { __typename?: 'Query', car?: { __typename?: 'CarNode', id: string, positions: { __typename?: 'CarPositionNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CarPositionNodeEdge', node?: { __typename?: 'CarPositionNode', id: string, startTime?: any | null, endTime?: any | null, location?: Types.CarCarPositionLocationChoices | null, driver?: { __typename?: 'DriverNode', id: string, name: string, customer: { __typename?: 'CustomerNode', id: string, name: string, email?: string | null, title?: Types.CustomersCustomerTitleChoices | null, additionalPhone?: string | null, phone?: string | null, fax?: string | null, additionalFax?: string | null, address?: string | null, additionalAddress?: string | null, city?: string | null, country?: string | null, zip?: number | null, bankAccountNumber?: string | null, branchNumber?: string | null, type: Types.CustomersCustomerTypeChoices, contactName?: string | null, companyNumber?: string | null } } | null, customer?: { __typename?: 'CustomerNode', id: string, name: string, email?: string | null, title?: Types.CustomersCustomerTitleChoices | null, additionalPhone?: string | null, phone?: string | null, fax?: string | null, additionalFax?: string | null, address?: string | null, additionalAddress?: string | null, city?: string | null, country?: string | null, zip?: number | null, bankAccountNumber?: string | null, branchNumber?: string | null, type: Types.CustomersCustomerTypeChoices, contactName?: string | null, companyNumber?: string | null } | null, deal?: { __typename?: 'DealNode', id: string } | null } | null } | null> } } | null };


export const AllCarPositionsDocument = gql`
    query AllCarPositions($id: ID!, $offset: Int, $before: String, $after: String, $first: Int, $last: Int) {
  car(id: $id) {
    id
    positions(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        node {
          id
          startTime
          endTime
          location
          driver {
            id
            name
            customer {
              id
              name
              email
              title
              additionalPhone
              phone
              fax
              additionalFax
              address
              additionalAddress
              city
              country
              zip
              bankAccountNumber
              branchNumber
              type
              contactName
              companyNumber
            }
          }
          customer {
            id
            name
            email
            title
            additionalPhone
            phone
            fax
            additionalFax
            address
            additionalAddress
            city
            country
            zip
            bankAccountNumber
            branchNumber
            type
            contactName
            companyNumber
          }
          deal {
            id
          }
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAllCarPositionsQuery__
 *
 * To run a query within a React component, call `useAllCarPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCarPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCarPositionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useAllCarPositionsQuery(baseOptions: Apollo.QueryHookOptions<AllCarPositionsQuery, AllCarPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCarPositionsQuery, AllCarPositionsQueryVariables>(AllCarPositionsDocument, options);
      }
export function useAllCarPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCarPositionsQuery, AllCarPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCarPositionsQuery, AllCarPositionsQueryVariables>(AllCarPositionsDocument, options);
        }
export type AllCarPositionsQueryHookResult = ReturnType<typeof useAllCarPositionsQuery>;
export type AllCarPositionsLazyQueryHookResult = ReturnType<typeof useAllCarPositionsLazyQuery>;
export type AllCarPositionsQueryResult = Apollo.QueryResult<AllCarPositionsQuery, AllCarPositionsQueryVariables>;